






import { Component, Prop, Provide } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import {
  ProvidedPanelParam,
} from './types';

/**
 * @event expanded-changed `(expandedPanels: string[])`
 */
@Component
export default class SwPanelGroup extends SwExtendedVue {
  // props
  @Prop({ type: Boolean, default: false })
  accordion:boolean;

  @Prop({
    type:[Array, String],
    default() { return []; },
  })
  initExpanded: string[] | string;

  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  // provide
  @Provide()
  panelParam: ProvidedPanelParam = {
    expandedPanels: ([] as string[]).concat(this.initExpanded),
    theme: this.theme,
  };

  @Provide()
  public claimPanelExpanded(panelId: string, expanded: boolean): void {
    let changed = false;

    if (!expanded) {
      const index = this.panelParam.expandedPanels.indexOf(panelId);
      if (index >= 0) {
        this.panelParam.expandedPanels.splice(index, 1);
        changed = true;
      }
    } else {
      if (this.accordion) {
        this.panelParam.expandedPanels.splice(0);
        this.panelParam.expandedPanels.push(panelId);
        changed = true;
      } else {
        const index = this.panelParam.expandedPanels.indexOf(panelId);
        if (index < 0) {
          this.panelParam.expandedPanels.push(panelId);
          changed = true;
        }
      }
    }

    if (changed) {
      this.$emit('expanded-changed', this.panelParam.expandedPanels.slice(0));
    }
  }

  created() {
    /** if accordion but we passed in multiple initial expanded ids, we will pick only the first one */
    if (this.accordion && this.panelParam.expandedPanels.length > 1) {
      this.panelParam.expandedPanels.splice(1);
    }
  }
}
